export default "__VITE_ASSET___uJkt2kf__"